import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import initialState from "./initial_state";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: initialState,
  mutations: {
    resetStore(state) {
      Object.assign(state, JSON.parse(localStorage.getItem("initialState")));
    },
    setUser(state, user) {
      state.userName = user;
    },
    setToken(state, token) {
      state.token = token;
    },
    setCognitoUser(state, cognitoUser) {
      state.cognitoUser = cognitoUser;
    },
    setExpTime(state, expTime) {
      state.expTime = expTime;
    },
    setUseTimeZone(state, timeZone) {
      state.useTimeZone = timeZone;
    },
    setUseSignal(state, useSignal) {
      state.useSignal = useSignal;
    },
    setUsePresence(state, usePresence) {
      state.usePresence = usePresence;
    },
    setLastSendTime(state, time) {
      state.lastSendTime = time;
    },
    setUserPool(state, userPool) {
      state.userPool = userPool;
    },
    setLanguage(state, language) {
      state.language = language;
    },
    setUserIsSpread(state, userIsSpread) {
      state.userIsSpread = userIsSpread;
    }
  },
  plugins: [createPersistedState()],
});

export default store;
